import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import RecipeList from './components/RecipeList';
import RecipeDetail from './components/RecipeDetail';
import CategoryView from './components/CategoryView';
import { recipes } from './data/recipes';
import { useState } from 'react';

function App() {
  const [searchTerm, setSearchTerm] = useState("");

  // Move the filtering logic here so it's available to all components
  const getFilteredRecipes = (category = null) => {
    return recipes.filter(recipe => {
      const matchesSearch = recipe.name.toLowerCase().includes(searchTerm.toLowerCase());
      if (category) {
        return matchesSearch && recipe.category === category;
      }
      return matchesSearch;
    });
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout searchTerm={searchTerm} setSearchTerm={setSearchTerm} />}>
          <Route index element={
            <div className="p-8">
              <h1 className="text-3xl font-bold mb-6">All Recipes</h1>
              <RecipeList recipes={getFilteredRecipes()} />
            </div>
          } />
          <Route 
            path="category/:category" 
            element={<CategoryView getFilteredRecipes={getFilteredRecipes} />}
          />
          <Route 
            path="recipe/:id" 
            element={<RecipeDetail recipes={recipes} />} 
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;